import * as React from 'react';

import { Text, View } from '@react-pdf/renderer';

import { Disease } from 'src/models/Disease.model';
import { handleNSI18Next } from 'src/models/Language.model';
import { Session } from 'src/models/Session.model';

import { cls } from 'src/utils/reactPdfStyles';

import GradingSummaryText from './GradingSummaryText';

interface ISummarySectionProps {
  session: Session;
  historyIndex?: number;
}

const SummarySection: React.FC<ISummarySectionProps> = ({
  session,
  historyIndex,
}) => {
  const { handleReportT } = handleNSI18Next();

  return (
    <>
      <View>
        <Text style={cls('section-text lead mt-4')}>
          {handleReportT('summarySection.title')}
        </Text>
      </View>

      <View style={cls('border-top pt-4')}>
        {GradingSummaryText(session, Disease.GLAUCOMA, historyIndex)}

        {GradingSummaryText(session, Disease.DR, historyIndex)}

        {GradingSummaryText(session, Disease.AMD, historyIndex)}
      </View>
    </>
  );
};

export default SummarySection;
